import type { FormSubmissionDto } from "../../types/submission";
import { normalizeSubmission } from "./normalizeSubmission";

export const EXTERNAL_SUBMISSION_UNAVAILABLE_MESSAGE = "Ответ недоступен";

function readRecord(raw: unknown): Record<string, unknown> | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const record = raw as Record<string, unknown>;
  if (
    record.data &&
    typeof record.data === "object" &&
    !Array.isArray(record.data)
  ) {
    return record.data as Record<string, unknown>;
  }
  return record;
}

export function unwrapSubmissionBody(raw: unknown): unknown {
  const record = readRecord(raw);
  return record ?? raw;
}

export function normalizeExternalSubmission(
  raw: unknown,
): FormSubmissionDto | null {
  const submission = normalizeSubmission(unwrapSubmissionBody(raw));
  return submission;
}

export const EXTERNAL_SUBMISSION_TOKEN_QUERY = "serviceToken";
export const LEGACY_EXTERNAL_SUBMISSION_TOKEN_QUERY =
  "externalSubmissionToken";

export function buildExternalSubmissionPath(uuid: string, token: string): string {
  const trimmedUuid = uuid.trim();
  const trimmedToken = token.trim();
  const params = new URLSearchParams();
  params.set(EXTERNAL_SUBMISSION_TOKEN_QUERY, trimmedToken);
  return `/submissions/${encodeURIComponent(trimmedUuid)}?${params.toString()}`;
}

export function getExternalSubmissionUrl(uuid: string, token: string): string {
  const path = buildExternalSubmissionPath(uuid, token);
  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }
  return path;
}

/** Страница UI: токен в query. API использует только Bearer. */
export function buildExternalSubmissionPathTemplate(token?: string | null): string {
  const trimmed = token?.trim();
  if (trimmed) {
    return `/submissions/{uuid}?${EXTERNAL_SUBMISSION_TOKEN_QUERY}=${encodeURIComponent(trimmed)}`;
  }
  return `/submissions/{uuid}?${EXTERNAL_SUBMISSION_TOKEN_QUERY}={serviceToken}`;
}

export function getExternalSubmissionUrlTemplate(
  token?: string | null,
): string {
  const path = buildExternalSubmissionPathTemplate(token);
  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }
  return path;
}
